import React from "react";

const BS5_InterviewPrep = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_InterviewPrep Component</h2>
      <p>This is the BS5_InterviewPrep component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_InterviewPrep;
